import { http } from "../../../common/http";

interface ProductParam {
    typeId?: number;
}

export const getProductList = (params: ProductParam) => {
    return http({
        method: 'GET',
        url: '/product',
        params
    });
}

export const getProductDetail = (id: number) => {
    return http({
        url: `/product/${id}`,
        method: "GET"
    })
}